import { DefaultApi as ClickUpAPI } from "./api/defaultApi";

export default ClickUpAPI;
